import React from "react";
import { dropDown } from "../asset";

type SelectOption =
  | string
  | {
      label: string;
      value: string | number;
    };

interface CustomSelectProps {
  name: string;
  value: string | number | string[];
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  options?: SelectOption[];
  label?: string;
  placeholder?: string;
  required?: boolean;
  id?: string;
  className?: string;
  selectClassName?: string;
  disabled?: boolean;
  readOnly?: boolean;
  optionClassName?: string;
  onClick?: () => void;
  openAsPopup?: boolean;
  multiple?: boolean;
}

export default function CustomSelect({
  name,
  value,
  onChange,
  options,
  label,
  placeholder,
  required = false,
  id,
  className = "",
  selectClassName = "",
  disabled,
  readOnly,
  optionClassName,
  onClick,
  openAsPopup = false,
  multiple = false
}: CustomSelectProps) {
  const handleMouseDown = (e: React.MouseEvent) => {
    if (openAsPopup) {
      e.preventDefault();
      if (onClick) onClick();
    }
  };

  return (
    <div
      onClick={openAsPopup ? onClick : undefined}
      className={`flex flex-col gap-2 w-full relative ${className} ${
        disabled ? "opacity-50" : ""
      }`}
    >
      {label && (
        <label
          htmlFor={id || name}
          className="text-[13px] font-semibold text-neutral-400 flex items-center"
        >
          {label}
          {required && <span className="text-error-500">*</span>}
        </label>
      )}

      <div className="relative">
        <select
          id={id || name}
          name={name}
          value={value}
          onChange={onChange}
          multiple={multiple}
          required={required}
          onMouseDown={handleMouseDown}
          disabled={disabled || readOnly}
          className={`px-4 py-[9px] pr-10  border border-neutral-100 placeholder:text-neutral-200 font-normal rounded outline-none text-[13px] text-gray-800 transition appearance-none w-full ${selectClassName} ${
            readOnly ? "bg-background-200" : ""
          } ${value ? optionClassName : ""}`}
        >
          {placeholder && <option value="">{placeholder}</option>}

          {options?.map((option) => {
            if (typeof option === "string") {
              return (
                <option key={option} value={option}>
                  {option}
                </option>
              );
            }

            return (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            );
          })}
        </select>
        <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none">
          <img src={dropDown} alt="" className="w-4 h-4" />
        </div>
      </div>
    </div>
  );
}
